module.exports = __webpack_public_path__ + "img/3-1.2dd86f63.png";